import React from 'react'
import PropTypes from 'prop-types'

const FooterAdmin = ({ config }) => {
  return (
    <footer className='footer p-0'>
      <div className='row px-3 px-lg-5 py-3 py-lg-0'>
        {/* Copyright */}
        <div className='col-12 text-center'>
          <div className='mx-auto mx-md-0'>{`Copyright © ${new Date().getFullYear()}`} <span className='text-capitalize'>{config.state} HAF</span></div>
        </div>
      </div>
    </footer>
  )
}

FooterAdmin.propTypes = {
  config: PropTypes.object
}

export default FooterAdmin
